export default "__VITE_ASSET__BO0ryAfL__"